module.exports = __webpack_public_path__ + "fb8731a16affea7ba43631e5fae43f37.png";